// extracted by mini-css-extract-plugin
module.exports = {"friendList":"FriendsList_friendList__2q5gL"};